// NetworkBanner — connection-level retry per design-system §4.
//
// **Two retry patterns (§4):**
//   1. inline `result.retry` — action-specific failures (one bubble's worth).
//   2. **this banner** — connection-level failures (network down, /chat 5xx
//      with no envelope, repeated timeouts).
//
// The banner sits at the very top of the chat surface (above the header),
// renders only when `connected === false`, and offers a single-tap retry
// of the last failed message. Tap → re-fires the most recent error bubble's
// payload via the parent's retry handler. Banner stays mounted until the
// retry succeeds (parent flips connected → true).
//
// **Why above the header:** when a connection breaks, the user shouldn't
// have to scroll or open a panel to find the recovery action. Spec calls
// for top-banner explicitly, distinct from the header status pill.

type Props = {
  /** When false, banner renders. When true, banner is hidden. */
  connected: boolean;
  /** Click handler for the retry button. Parent decides what to retry. */
  onRetry: () => void;
  /** When true, the banner shows the retry button. Disable while a retry
   *  is in flight (parent's `pending` flag) to avoid double-fire. */
  retryEnabled: boolean;
};

export const NetworkBanner = ({ connected, onRetry, retryEnabled }: Props) => {
  if (connected) return null;
  return (
    <div
      role="alert"
      className="flex shrink-0 items-center justify-between gap-3 bg-[var(--color-bad)] px-4 py-2 text-xs font-bold text-white"
    >
      <span>אין חיבור</span>
      <button
        type="button"
        onClick={onRetry}
        disabled={!retryEnabled}
        className="rounded-md bg-white/20 px-3 py-1 text-xs font-bold text-white hover:bg-white/30 disabled:opacity-50"
      >
        נסו שוב
      </button>
    </div>
  );
};
